module.exports = __webpack_public_path__ + "ed7867a42914f68284fb7b1b9b90880c.MP3";